<template>
    <div class="jump-gooddetail">
        <van-nav-bar title="商品详情" left-arrow fixed
                     @click-left="back">
        </van-nav-bar>
        <van-swipe class="jump-gooddetail-swipe" :autoplay="3000">
            <van-swipe-item>
                <img :src="good.imges" style="width:100%;height:100%">
            </van-swipe-item>
        </van-swipe>
        <van-row class="detail-header" type="flex">
            <van-col span="20">
                <h4><span>商品积分：</span>{{good.integral}}积分</h4>
                <h4 style="font-size: 16px"><span style="font-size: 16px">库存</span>{{good.stock}}</h4>
                <h5><span>销售单位：</span>{{good.goodsUnit}}</h5>
                <h5>{{good.name}}</h5>
              
            </van-col>
            <van-col span="4" class="text-right">
            </van-col>
        </van-row>

        <div class="detail-active">
            <van-cell title="兑换量" :value="good.ordernum" style="padding:0"/>
        </div>
        <div class="detail-show" id="GoodDetail">
            <h5>产品展示</h5>
            <div class="gooddetail" v-html="good.goodDetail">
            </div>
        </div>
        <van-goods-action>
            <van-goods-action-big-btn text="立即兑换" class="btn-buy" @click="buy" v-if="level >= good.memberLevel&&isShow"/>
            <van-goods-action-big-btn :text="'所需等级:'+good.levelName" class="btn-buy" v-if="level < good.memberLevel" disabled="disabled"/>
        </van-goods-action>
    </div>
</template>
<script>
    import {
        NavBar, Swipe, SwipeItem, GoodsAction, GoodsActionBigBtn, GoodsActionMiniBtn, Row, Col, Cell,Dialog
    } from "vant";

    export default {
        name: "integralgooddetail",
        components: {
            [NavBar.name]: NavBar,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [GoodsAction.name]: GoodsAction,
            [GoodsActionBigBtn.name]: GoodsActionBigBtn,
            [GoodsActionMiniBtn.name]: GoodsActionMiniBtn,
            [Row.name]: Row,
            [Col.name]: Col,
            [Cell.name]: Cell,
            [Dialog.name]: Dialog
        },
        data() {
            return {
                goodsId: 0,
                good: {},
                goodImgs: [],
                level: localStorage.getItem("level"),
                integral:0,
                isShow:false
            };
        },
         created() {
            this.getIntergal();
            let that = this;
            this.goodsId = this.$route.params.goodsId;
            //商品详情
            this.$api.get(this.jumuc.integral.goodsDetail, {id: that.goodsId},
                successRes => {
                    if (successRes.success) {
                        that.good = successRes.data;
                    }
                })
        },
        methods: {
            getIntergal (){
                this.$api.get(this.jumuc.userCenter.getUserInfo,
                null,
                successRes => {
                    if (successRes.success) {
                        this.integral = successRes.data.user.integral;
                        this.isShow=true;
                    }
                })
            },
            back() {
                history.back();
            },
            buy() {
                let that = this;
                if(that.integral<that.good.integral){
                    that.$toast("您的积分不足，暂不能兑换,快去赚积分吧");
                    return;
                }else{
                    location.href = "#/integral/order?goodsId=" + this.goodsId
                }
                // if (that.$api.isLogin()) {
                //     location.href = "#/integral/order?goodsId=" + this.goodsId
                // } else {
                //     location.href = "#/login";
                // }
            },
        },
       
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;
    body {
        background-color: #f7f7f7;
    }

    .jump-gooddetail {
        padding: 0px 0px 50px 0;
        &-header {
            position: fixed;
            top: 0px;
            left: 0px;
            width: 100%;
            padding: 5px 0;
            background-color: @bule-thame;
            z-index: 9999;
            .navbar-items a {
                color: #f7f7f7;
                display: inline-block;
                line-height: 40px;
                margin: 0 10px;

                &.active {
                    border-bottom: 1px solid #f7f7f7;
                }
            }
        }
        &-navbar {
            &-arrow {
                line-height: 40px;
                text-align: center;
            }
            i {
                font-size: 24px;
                color: #ffffff;
                vertical-align: -5px;
            }
            input {
                border-radius: 15px;
            }
        }
        &-swipe {
            height: 300px;
            min-width: 100%;
            text-align: center;
            background-color: #fff;
            margin-bottom: 5px;
            img {
                width: 100%;
            }
        }
        .btn-cart {
            background-color: #f5a623;
            border-color: #f5a623;
        }
        .btn-buy {
            background-color: #f57c23;
            border-color: #f57c23;
        }
        .detail-header, .detail-active, .detail-comment, .detail-info, .detail-show {
            background-color: #fff;
            padding: 10px 15px;
            margin-bottom: 10px;

            h5 {
                font-size: 16px;
                color: #000;
                line-height: 150%;
            }
        }

        .detail-comment, .detail-info, .detail-show {
            padding: 20px 15px 15px;
            h5 {
                margin-bottom: 10px;
            }
        }
        .detail-info p span {
            display: inline-block;
            width: 60px;
        }
        .detail-header {
            h4 span {
                font-size: 18px;
                margin-right: 5px;
            }
            h4, i {
                font-size: 24px;
                color: #d0021b;
            }
            i.detail-share {
                display: inline-block;
                margin-left: 5px;
                color: #666;
                font-size: 26px;
                vertical-align: -2px;
            }
        }
        p {
            padding: 2px 0 4px;
            font-size: 14px;
            color: #666;
            line-height: 150%;
            span, img {
                margin-right: 5px;
            }
        }
        p.comment-more {
            color: #f5a623;
            text-align: right;
        }
        p.comment-tag {
            line-height: 200%;
            padding: 10px 0;
            span {
                display: inline-block;
                border: 1px solid @bule-thame;
                padding: 0 10px;
                margin-right: 15px;
                margin-bottom: 15px;
                border-radius: 8px;
                color: @bule-thame;
                &.active {
                    background-color: @bule-thame;
                    color: #fff;
                }
            }
        }
        .comment-item {
            padding-top: 10px;
        }

        .detail-show {
            img {
                width: 100%;
            }
        }

    }
</style>
